import { useQuery } from '@tanstack/react-query';
import { fetchFeatureFlags } from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useFeatureFlags = () =>
  useQuery({
    queryFn: () => extractData(fetchFeatureFlags()),
    queryKey: ['featureFlags'],
  });

export const useFeatureFlag = (featureName: string) =>
  useQuery({
    queryFn: () => extractData(fetchFeatureFlags()),
    queryKey: ['featureFlags'],
    select(data) {
      const feature = data?.featureFlags?.find(
        (flag) => flag.feature === featureName
      );
      return feature?.isEnabled ?? false;
    },
  });
